'use strict';

export function UserResource($resource) {
  'ngInject';

  return $resource('/api/users/:id/:controller', {
    id: '@_id'
  }, {
    changePassword: {
      method: 'PUT',
      params: {
        controller: 'password'
      }
    },
    forgotPassword: {
      method: 'PATCH',
      params: {
        id: 'forgot',
        controller: 'password'
      }
    },
    resetPassword: {
      method: 'PATCH',
      params: {
        controller: 'reset'
      }
    },
    changeEmail: {
      method: 'PATCH',
      params: {
        controller: 'email'
      }
    },
    update: {
      method: 'PATCH'
    },
    updateResidencies: {
      method: 'PATCH',
      params: {
        controller: 'residencies'
      },
      isArray: true
    },
    getOne: {
      method: 'GET'
    },
    get: {
      method: 'GET',
      params: {
        id: 'me'
      }
    },
    getResidencies: {
      method: 'GET',
      params: {
        controller: 'residencies'
      }
    },
    sendFeedback: {
      method: 'POST',
      params: {
        controller: 'feedback'
      }
    }
  });
}



// WEBPACK FOOTER //
// ./client/~ap/auth/user.service.js